function lowerCase(str) {
  return str.toLowerCase();
}
export {
  lowerCase
};
//# sourceMappingURL=index.js.map
